/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum JobProfile {
  Lawyer = "Lawyer",
  LegalSupportProfessional = "LegalSupportProfessional",
}

export const JobProfileDisplay: Record<JobProfile, string> = {
  [JobProfile.Lawyer]: "Lawyer",
  [JobProfile.LegalSupportProfessional]: "Legal Support Professional",
};
